import React, { useState } from "react";
import "jquery-ui-dist/jquery-ui";
import "jquery-ui-dist/jquery-ui.css";
import { useEffect } from "react";

const FilterTab = ({
  title,
  filterOptions,
  setSelectedFilters,
  selectedFilters,
}) => {
  const handleCheckboxChange = (e, filterId) => {
    const isChecked = e.target.checked;
    setSelectedFilters((prevFilters) => {
      if (isChecked) {
        return [...prevFilters, filterId];
      } else {
        return prevFilters.filter((id) => id !== filterId);
      }
    });
  };

  return (
    <div className="sidebar-body">
      <ul className="checkbox-container categories-list" style={{ padding: 0 }}>
        {filterOptions?.map((option, index) => (
          <li key={option?._id}>
            <div className="custom-control custom-checkbox">
              <input
                type="checkbox"
                name={title}
                value={option?._id}
                onChange={(e) => handleCheckboxChange(e, option?._id)}
                className="custom-control-input"
                checked={selectedFilters.includes(option?._id)}
                id={`modalCustomCheck-${title.split(" ")[0]}-${index}`}
              />
              <label
                className="custom-control-label"
                htmlFor={`modalCustomCheck-${title.split(" ")[0]}-${index}`}
              >
                {option.name}
              </label>
            </div>
          </li>
        ))}
      </ul>
    </div>
  );
};

const FilterTabs = ({
  filters,
  setSelectedFilters,
  priceRange,
  setPriceFilter,
  selectedFilters,
  priceFilter,
}) => {
  const [activeTab, setActiveTab] = useState("price");
  const [min, setMin] = useState(0);
  const [max, setMax] = useState(0);

  useEffect(() => {
    setMin(priceFilter.min);
    setMax(priceFilter.max);
  }, [priceFilter]);

  const handleFilter = () => {
    setPriceFilter({ min, max });
  };
  const handleClear = () => {
    setPriceFilter(priceRange);
  };

  return (
    <>
      <div className="modal-body">
        <div className="product-details-reviews pt-2">
          <div className="row">
            <div className="col-lg-12">
              <div className="product-review-info">
                <ul className="nav review-tab">
                  <li>
                    <a
                      className={activeTab === "price" ? `active` : ""}
                      data-bs-toggle="tab"
                      href="#"
                      onClick={(e) => {
                        e.preventDefault();
                        setActiveTab("price");
                      }}
                    >
                      Price
                    </a>
                  </li>
                  {filters?.map((filter) => (
                    <li key={filter._id}>
                      <a
                        className={activeTab === filter._id ? `active` : ""}
                        data-bs-toggle="tab"
                        href="#"
                        onClick={(e) => {
                          e.preventDefault();
                          setActiveTab(filter._id);
                        }}
                      >
                        {filter?.name}
                      </a>
                    </li>
                  ))}
                </ul>
                <div className="tab-content reviews-tab">
                  {filters?.map((filter) => (
                    <div
                      key={filter._id}
                      className={`tab-pane fade ${
                        activeTab === filter._id ? "show active" : ""
                      }`}
                    >
                      <div className="tab-content">
                        <FilterTab
                          title={filter?.name}
                          filterOptions={filter.filterOptions}
                          setSelectedFilters={setSelectedFilters}
                          selectedFilters={selectedFilters}
                        />
                      </div>
                    </div>
                  ))}
                  <div
                    className={`tab-pane fade ${
                      activeTab === "price" ? "show active" : ""
                    }`}
                  >
                    <div className="tab-content">
                      <div className="sidebar-body">
                        {/* <div className="price-range-wrap">
                          <div ref={sliderRef} className="price-range"></div>
                          <div className="range-slider"> */}
                        <form className="d-flex flex-column gap-2 ">
                          <div className="d-flex gap-4 flex-wrap">
                            <div className="custom-control d-flex gap-2">
                              <label htmlFor="modalAmountMin">Min: </label>
                              <input
                                type="text"
                                id="modalAmountMin"
                                value={min}
                                onChange={(e) => {
                                  setMin(e.target.value);
                                }}
                                className="custom-control-input "
                                style={{
                                  maxWidth: "100px",
                                  background: "#ebebeb",
                                  border: "none",
                                  borderRadius: "10px",
                                  paddingLeft: "5px",
                                }}
                              />
                            </div>
                            <div className="custom-control d-flex gap-2">
                              <label htmlFor="modalAmountMax">Max: </label>
                              <input
                                type="text"
                                id="modalAmountMax"
                                value={max}
                                onChange={(e) => {
                                  setMax(e.target.value);
                                }}
                                className="custom-control-input"
                                style={{
                                  maxWidth: "100px",
                                  background: "#ebebeb",
                                  border: "none",
                                  borderRadius: "20px",
                                  paddingLeft: "5px",
                                }}
                              />
                            </div>
                          </div>
                          <div className="d-flex justify-content-between align-items-center" style={{paddingTop:"10px"}}>
                            <button
                              type="button"
                              onClick={handleClear}
                              className="filter-btn"
                            >
                              Clear
                            </button>
                            <button
                              type="button"
                              className="filter-btn"
                              onClick={handleFilter}
                            >
                              Apply
                            </button>
                          </div>
                        </form>
                        {/* </div>
                        </div> */}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default FilterTabs;
